import { STEP_LINK_QUERY_PARAM_NAME } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import { PAGE_LINK_QUERY_PARAM } from 'Views/Page/Contexts/PageContentContext';
import { useHistory } from 'react-router-dom';


export default function useWizardComplete(onComplete) {
  const history = useHistory();

  function handleNext() {
    // handle use case for embedded wizard in the onboarding
    const params = new URLSearchParams(history.location.search);
    // is this wizard embedded inside an onboarding step?
    if (params.has(STEP_LINK_QUERY_PARAM_NAME)) {
      params.delete(PAGE_LINK_QUERY_PARAM);
      history.replace(`${history.location.pathname}?${params}`);
    } else if (onComplete) {
      onComplete();
    }
  }

  return {
    handleNext,
  };
}
